// DignifiedPersonalCareSection.js
import React from "react";
import { Phone } from "lucide-react";
import dignifiedPersonalCareImage from "../assets/dignified-personal-care-image.jpg";

const DignifiedPersonalCareSection = () => {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Dignified In-Home Personal Care For Seniors In the Riverina
            </h2>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-8">
              <p>
                Most of us wake up and start out our days using the bathroom,
                bathing, dressing and grabbing a bite to eat. For many seniors
                this{" "}
                <span className="text-[#E85D2C] font-normal">
                  daily routine
                </span>{" "}
                is not so easy as they struggle to carry out some of these basic
                personal care activities. When it happens to your aging family
                member, you want them to remain at home while enjoying the
                independence and dignity they deserve. Having a conversation
                with a senior loved one, especially a parent, about personal
                care can be embarrassing, and feelings oftentimes get hurt.
              </p>

              <p>
                To assist your efforts, Allawah Lodge offers reliable and
                discreet personal caregiving assistance for seniors that's
                delivered by our certified home health aides. In fact, our
                personal care services are quickly becoming the preferred
                in-home senior care choice families throughout Coolamon, Wagga
                Wagga, and surrounding areas. We've found that by bringing in a
                non-family caregiver to your loved one's home that they are
                typically more receptive to receiving the personal care they
                deserve.
              </p>
            </div>

            <a
              href="tel:+61269272706"
              className="inline-flex items-center gap-2 bg-[#E85D2C] hover:bg-[#d54d1f] text-white font-medium px-6 py-3 rounded-full transition-colors"
            >
              <Phone size={20} />
              CALL: (02) 6927 2706
            </a>
          </div>

          {/* Right Image */}
          <div>
            <img
              src={dignifiedPersonalCareImage}
              alt="Caregiver with elderly woman outdoors"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DignifiedPersonalCareSection;
